export default "__VITE_ASSET__BVs30_rv__"